<template>
    <v-card class="full-h d-flex" v-resize="resize">
        <LoadingSkeleton
			v-if="isLoading"
			:style="{ height: cardHeight + 'px' }"
		/>
        <AgentNavigationDrawer
            v-if="!isLoading"
            @changedSelectedContract="selectedContract = $event"
            @changedSelectedContractId="selectedContractId = $event"
        />
        <AgentMainVue
            v-if="!isLoading"
            :selectedContract="selectedContract"
            :selectedContractId="selectedContractId"
        />
    </v-card>
</template>

<script>
import AgentNavigationDrawer from './AgentNavigationDrawer.vue';
import AgentMainVue from './AgentMain.vue';
import { mapState } from 'vuex';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    components: {
        AgentNavigationDrawer,
        AgentMainVue,
        LoadingSkeleton,
    },
    data: () => ({
        selectedContract: {},
        selectedContractId: null,
        cardHeight: 1000,
    }),
    methods: {
		resize() {
			this.cardHeight = window.innerHeight - 44 - 24;
		},
    },
    computed: {
        ...mapState('agent', {
            isLoading: (state) => state.isLoading,
        }),
    },
};
</script>

<style scoped>
.full-h {
    height: 100%;
}
</style>
